module.exports = __webpack_public_path__ + "img/coating-static.a4357525.svg";